var _excluded = ["types"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { Fragment } from 'react';
import { BuildingIcon, DevelopmentSizeIcon, DevelopmentIcon, LeisureIcon, IndustrialIcon, OfficeIcon, RetailIcon, BedIcon, BathIcon, ParkingIcon, EerIcon } from '@domain-group/fe-co-icon';
import { ListingType, PropertyType } from '@domain-group/fe-allhomes-library';
import * as styles from './allhomes-listing-card-features.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AllhomesListingCardFeatures = _ref => {
  var _props$eer;
  var _ref$types = _ref.types,
    types = _ref$types === void 0 ? [] : _ref$types,
    props = _objectWithoutProperties(_ref, _excluded);
  var Icons = {
    [PropertyType.COMMERCIAL_LAND.name]: DevelopmentIcon,
    [PropertyType.HOTEL.name]: LeisureIcon,
    [PropertyType.INDUSTRIAL.name]: IndustrialIcon,
    [PropertyType.MOTEL.name]: LeisureIcon,
    [PropertyType.OFFICE.name]: OfficeIcon,
    [PropertyType.RETAIL.name]: RetailIcon,
    [PropertyType.WAREHOUSE.name]: IndustrialIcon,
    [PropertyType.OTHER_COMMERCIAL.name]: BuildingIcon
  };
  var propertyType = types && types[0];
  var PropertyTypeIcon = Icons[propertyType === null || propertyType === void 0 ? void 0 : propertyType.toUpperCase()] || BuildingIcon;
  var propertyTypeLabel = PropertyType[propertyType] ? PropertyType[propertyType].label : 'Other';
  var renderFeatureIcon = (SelectedIcon, value, title) => {
    if (value) {
      return ___EmotionJSX("span", {
        css: styles.item
      }, ___EmotionJSX("span", null, ___EmotionJSX(SelectedIcon, {
        css: styles.itemIcon,
        title: title,
        size: "small"
      })), ___EmotionJSX("span", {
        css: styles.itemValue
      }, value));
    }
    return null;
  };
  var isResi = props.listingType === ListingType.SALES_RESIDENTIAL.name || props.listingType === ListingType.RENTAL_RESIDENTIAL.name || props.listingType === ListingType.SHARE_RESIDENTIAL.name;
  var showEer = isResi && props.listingType !== ListingType.SHARE_RESIDENTIAL.name && props.eer != null && props.eer >= 0;
  var isCommercial = props.listingType === ListingType.SALES_COMMERCIAL.name || props.listingType === ListingType.RENTAL_COMMERCIAL.name;
  var hasTypeSeparator = Boolean(isResi && (props.beds || props.baths || props.cars || props.eer) || props.size && isCommercial);
  var isNewHomes = props.listingType === ListingType.DEVELOPMENTS_RESIDENTIAL.name;
  var displayPropertyType = propertyType && (isResi || isCommercial || isNewHomes);
  return ___EmotionJSX("div", {
    css: styles.features
  }, isResi && ___EmotionJSX(Fragment, null, renderFeatureIcon(BedIcon, props.beds, 'Bedrooms'), renderFeatureIcon(BathIcon, props.baths, 'Bathrooms'), renderFeatureIcon(ParkingIcon, props.cars, 'Parking'), showEer && renderFeatureIcon(EerIcon, (_props$eer = props.eer) === null || _props$eer === void 0 ? void 0 : _props$eer.toFixed(1), 'EER')), Boolean(props.size && isCommercial) && ___EmotionJSX("div", null, ___EmotionJSX("span", {
    css: styles.typeSizeIcon
  }, ___EmotionJSX(DevelopmentSizeIcon, null)), ___EmotionJSX("span", {
    css: styles.typeSizeValue(false)
  }, props.size, " m", ___EmotionJSX("span", {
    css: styles.sizeValueSup
  }, "2"))), displayPropertyType && ___EmotionJSX("div", {
    css: styles.type
  }, isCommercial && ___EmotionJSX("span", {
    css: styles.typeSizeIcon
  }, ___EmotionJSX(PropertyTypeIcon, {
    title: propertyTypeLabel
  })), (isResi || isCommercial) && ___EmotionJSX("span", {
    css: styles.typeSizeValue(hasTypeSeparator)
  }, PropertyType[propertyType] ? PropertyType[propertyType].label : 'Other')));
};
export default AllhomesListingCardFeatures;